import Repository from "./Repository";
import { Training } from "../types/Training";
import BaseResponse from "../types/BaseResponse";
import TrainingAssignments from "../types/TrainingAssignments";

const resource = "/training";

export default {
  getByCompany(companyId: string) {
    return Repository.get<BaseResponse<Training[]>>(
      `${resource}/company/${companyId}/all`
    );
  },
  getPublishedByCompany(companyId: string) {
    return Repository.get<BaseResponse<Training[]>>(
      `${resource}/company/${companyId}`
    );
  },
  getTopicsByTrainingId(trainingId: string, trainingVersion: string) {
    return Repository.get<BaseResponse<Training>>(
      `${resource}/${trainingId}/version/${trainingVersion}`
    );
  },
  save(training: Training) {
    if (training.trainingId) {
      return Repository.patch<BaseResponse<Training>>(`${resource}`, training);
    } else {
      return Repository.post<BaseResponse<Training>>(`${resource}`, training);
    }
  },
  activateTraining(training: Training) {
    return Repository.patch<BaseResponse<Training>>(
      `${resource}/${training.trainingId}/activateTraining`,
      training
    );
  },
  copy(training: Training) {
    return Repository.get<BaseResponse<Training>>(
      `${resource}/${training.trainingId}/${training.trainingVersion}`
    );
  },
  publish(training: Training, overrideAssignments: boolean) {
    return Repository.post<BaseResponse<Training>>(
      `${resource}/publish/${training.trainingId}/${training.trainingVersion}?overrideAssignments=${overrideAssignments}`
    );
  },
  getAssignments(
    trainingId: string,
    trainingVersion: string,
    companyId: string
  ) {
    return Repository.get<BaseResponse<TrainingAssignments>>(
      `${resource}/${trainingId}/version/${trainingVersion}/assignments?companyId=${companyId}`
    );
  },
  getAssignmentsBackup(trainingId: string, trainingVersion: string) {
    return Repository.get<BaseResponse<TrainingAssignments>>(
      `${resource}/${trainingId}/assignments`
    );
  },
};
